// extracted by mini-css-extract-plugin
export default {"root":"api-key_root__+Ex31","icon":"api-key_icon__OJ7aJ"};